/* External */
import { useMemo } from 'react';

/* Utils */
import { useIsBrazil } from '../../providers/ConfigProvider';
import {
  useAllGenres,
  useFullEpisodeName,
  isEpisode,
  isMovie,
  isEvent,
  isChannel,
  isSports,
  joinArrayWithSpace,
  getRating,
  joinArrayWithSeparator,
  getFirstGenre,
} from '../../utils/metaDataUtils';
import { DOT_SEPARATOR } from '../../utils/constants';

export function useSubtitleLiveCard(content) {
  const isBrazil = useIsBrazil();

  const fullEpisodeName = useFullEpisodeName(content);
  const allGenres = useAllGenres(content);

  let baseSubtitle = content?.shortName;

  if (isEpisode(content)) baseSubtitle = fullEpisodeName;

  if (isMovie(content) || isEvent(content)
    || isChannel(content) || isSports(content)) {
    baseSubtitle = allGenres;
  }

  if (isSports(content) && (content?.episode?.number ?? 0) <= 0) {
    baseSubtitle = joinArrayWithSeparator([content?.episode?.showName, allGenres], DOT_SEPARATOR);
  }

  if (isSports(content) && (content?.episode?.number ?? 0) <= 0
    && content?.title !== content?.episode?.showName) {
    baseSubtitle = joinArrayWithSeparator([content?.episode?.showName, getFirstGenre(content)]);
  }

  return useMemo(() => joinArrayWithSpace([
    isBrazil && getRating(content),
    baseSubtitle,
  ]), [baseSubtitle, content, isBrazil]);
}
